module.exports = __webpack_public_path__ + "static/media/Aether.f6f061bd.png";